import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63c6da42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "welcome-text__wrapper" }
const _hoisted_2 = { class: "welcome-text primary-font" }

import { onMounted, ref, watch } from "vue";
import { useContentStore } from "@/store/content";


export default /*#__PURE__*/_defineComponent({
  __name: 'WelcomeText',
  setup(__props) {

onMounted(() => {
  updateText();
});

const contentStore = useContentStore();

const text = ref("welcome");

const texts = {
  welcome: [
    "welcome", // English
    "bienvenido", // Spanish
    "willkommen", // German
    "bem-vindo", // Portuguese
    "benvenuto", // Italian
    "bienvenue", // French
    "välkommen", // Swedish
    "velkommen", // Norwegian
    "witaj", // Polish
  ],
  interactions: [
    "how are you?",
    "nice to meet you",
    ":)",
    "<3",
    "stay awhile",
    "made with love",
  ],
};

let textType = 0;
let intervalMs = 2000;
let timeoutId = 0;

const updateText = () => {
  intervalMs = 4000;
  clearTimeout(timeoutId);
  timeoutId = setTimeout(() => {
    text.value = useContentStore().fontLoaded ? text.value : "Incorrect font";

    let textArray = [] as string[];

    intervalMs = Math.random() * (10000 - 4000) + 4000;

    if (Math.random() > 0.45 || textType === 1) {
      textType = 0;
      textArray = texts.welcome;
    } else {
      textType = 1;
      textArray = texts.interactions;
    }

    const index = Math.round(Math.random() * (textArray.length - 1));
    const newText = textArray[index];
    text.value = newText;
    updateText();
  }, intervalMs);
};

watch(contentStore.getActive, async (to) => {
  if (to.id === 1) {
    text.value = "back again?";
    updateText();
  }
});

return (_ctx: any,_cache: any) => {
  const _directive_glitched = _resolveDirective("glitched")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("p", _hoisted_2, null, 512), [
      [_directive_glitched, text.value]
    ])
  ]))
}
}

})